// extracted by LIB_CSS_EXTRACT_LOADER
import "./breadcrumb_module.css"
export default {"root":"root-me55sz","list":"list-EcK2M1","item":"item-NgwWCI","link":"link-Rm532a","page":"page-F4a5dL","separator":"separator-QL_9rQ","ellipsis":"ellipsis-jAUXe_","srOnly":"srOnly-qF0F14"};